function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    var isMobile = props.isMobile;
    var isDark = props.isDark;
    return isMobile ? /*#__PURE__*/ _jsxs(Svg, {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "40",
                height: "40",
                rx: "20",
                fill: "#194BFB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M30.2874 20.789C30.6455 20.6392 31.0549 20.461 31.3908 20.3259C31.7025 20.1897 31.8474 19.8299 31.7167 19.5168L29.8784 15.1331C29.814 14.979 29.6902 14.8571 29.5348 14.7948C29.3794 14.7324 29.2054 14.7349 29.0519 14.8017C28.7614 14.9271 28.3855 15.0909 27.9798 15.2641C25.1242 16.4767 24.0001 15.2727 22.4445 12.4487L20.2931 8.55757C20.2117 8.41015 20.0738 8.30187 19.911 8.25741C19.7481 8.21295 19.5741 8.2361 19.4287 8.32158L15.3066 10.7352C15.0134 10.9085 14.9137 11.284 15.0825 11.5791C15.539 12.3967 16.4461 14.0241 17.2527 15.5028C20.1444 20.8366 24.0208 23.4028 30.2874 20.789Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.71269 19.2062C9.3546 19.356 8.94524 19.5343 8.60934 19.6693C8.29764 19.8055 8.1527 20.1653 8.28338 20.4785L10.1217 24.8622C10.1819 25.024 10.3069 25.1538 10.4667 25.2203C10.6266 25.2869 10.807 25.2843 10.9648 25.2131C11.2553 25.0877 11.6312 24.9239 12.037 24.7507C14.8926 23.5381 16.0167 24.7421 17.5722 27.5662L19.7189 31.4424C19.8004 31.5898 19.9382 31.6981 20.1011 31.7426C20.264 31.787 20.4379 31.7639 20.5834 31.6784L24.7055 29.2648C24.9987 29.0915 25.0984 28.716 24.9295 28.4209C24.4731 27.6033 23.566 25.9759 22.7594 24.4972C19.8557 19.1587 15.9757 16.5975 9.71269 19.2062Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        width: "125",
        height: "30",
        viewBox: "0 0 125 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M39.2327 21.718C41.21 22.9987 44.1888 23.6265 47.2703 23.6265C51.9696 23.6265 55.3335 21.5673 55.3335 17.5744C55.3335 14.5107 53.1765 12.9286 49.3503 12.4514L44.5996 11.8487C43.4954 11.6981 43.0075 11.4218 43.0075 10.6685C43.0075 9.53839 44.6253 9.1617 47.0648 9.1617C49.9152 9.1617 52.7399 10.2667 54.178 11.8739L53.4846 6.97691C51.9696 5.89708 49.6841 5.3446 46.6283 5.3446C41.6722 5.3446 38.5137 7.32849 38.5137 11.0954C38.5137 14.1089 40.3112 15.691 43.8036 16.143L48.7597 16.7959C50.172 16.9717 50.8397 17.2982 50.8397 18.1018C50.8397 19.282 49.5044 19.8094 47.0648 19.8094C44.2401 19.8094 41.1329 18.9054 38.5907 16.7959L39.2327 21.718Z",
                fill: isDark ? "white" : "#1A202C"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M60.4409 23.2749H64.8577L67.8622 14.5609L70.841 23.2749H75.2578L79.7773 10.116H75.1037L72.9466 17.5493L70.199 10.116H65.5767L62.829 17.5493L60.6977 10.116H55.9213L60.4409 23.2749Z",
                fill: isDark ? "white" : "#1A202C"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M84.1801 27.7952C87.0561 27.7952 88.186 26.7907 89.3416 24.0283L95.1708 10.116H90.5228L87.6725 17.3986L84.745 10.116H79.9173L85.2586 22.1198L85.1816 22.2955C84.7193 23.3503 84.3598 23.9279 83.0245 23.9279C82.3825 23.9279 81.6378 23.8274 80.9702 23.5261L81.5608 27.3432C82.2798 27.6445 83.2299 27.7952 84.1801 27.7952Z",
                fill: isDark ? "white" : "#1A202C"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M95.3341 16.6955C95.3341 20.8641 98.3899 23.5763 103.038 23.5763C105.195 23.5763 106.864 23.1243 107.84 22.3709L108.507 17.926C107.48 19.1063 105.914 19.8596 103.834 19.8596C101.24 19.8596 99.8536 18.4533 99.8536 16.6955C99.8536 14.9376 101.24 13.5313 103.783 13.5313C105.811 13.5313 107.403 14.4102 108.353 15.5152L107.686 11.0451C106.89 10.3169 105.298 9.81463 103.012 9.81463C98.3899 9.81463 95.3341 12.5268 95.3341 16.6955Z",
                fill: isDark ? "white" : "#1A202C"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M115.163 23.2749V14.6613C115.626 13.9582 116.524 13.6066 117.552 13.6066C119.041 13.6066 119.965 14.4604 119.965 15.917V23.2749H124.434V15.038C124.434 11.9241 122.867 9.81463 119.632 9.81463C116.91 9.81463 115.651 11.1707 115.163 13.682V4.44055L110.695 4.9428V23.2749H115.163Z",
                fill: isDark ? "white" : "#1A202C"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.17274 14.2967C3.32508 14.2326 3.47644 14.1688 3.62046 14.1091C10.6835 11.1927 15.0592 14.0559 18.3338 20.0242C19.2435 21.6773 20.2664 23.4967 20.7812 24.4108C20.9716 24.7407 20.8592 25.1605 20.5285 25.3541L15.8799 28.0525C15.7158 28.1481 15.5196 28.1739 15.3359 28.1242C15.1523 28.0745 14.9968 27.9535 14.9049 27.7887L12.484 23.4552C10.7297 20.298 9.46209 18.952 6.24163 20.3076C5.91573 20.4455 5.60688 20.5781 5.33776 20.6937C5.22904 20.7403 5.12681 20.7842 5.03256 20.8246C4.85453 20.9041 4.65108 20.907 4.47081 20.8326C4.29054 20.7582 4.14964 20.6132 4.08177 20.4322L2.00856 15.5314C1.86119 15.1813 2.02464 14.779 2.37616 14.6268C2.61988 14.5296 2.89789 14.4125 3.17274 14.2967ZM27.2714 15.6909C27.119 15.7551 26.9677 15.8188 26.8237 15.8785C19.7565 18.8006 15.3849 15.9317 12.1238 9.96877C11.2141 8.31564 10.1911 6.49632 9.67638 5.5822C9.48596 5.25231 9.59839 4.83251 9.92904 4.63882L14.5777 1.94047C14.7417 1.8449 14.938 1.81902 15.1216 1.86873C15.3053 1.91843 15.4608 2.03948 15.5526 2.20429L17.9789 6.55439C19.7331 9.71159 21.0008 11.0576 24.2212 9.70195C24.5471 9.56406 24.856 9.43145 25.1251 9.31589C25.2338 9.2692 25.336 9.2253 25.4303 9.18496C25.6035 9.11035 25.7997 9.10756 25.9749 9.17723C26.1502 9.24689 26.2897 9.38316 26.3623 9.55545L28.4356 14.4562C28.5829 14.8064 28.4195 15.2086 28.068 15.3608C27.8242 15.458 27.5462 15.5751 27.2714 15.6909Z",
                fill: "#194BFB"
            })
        ]
    }));
};
export default Icon;
